import { FormattedMessage } from 'react-intl';

import { FlexRow } from 'ui-components/components/flex/row';
import { Text, TextType } from 'ui-components/components/text';

import { messages } from '../../../pages/settings/components/add-on-tile/messages';
import { FormattedCurrency } from '../../formatted-currency';
import { ConfirmAddOnUpsellButton } from '../confirm-upsell-button/confirm-addon-upsell-button';
import { PaymentDisclaimer } from '../description/payment-disclaimer';

import styles from './add-on-footer.module.css';

import type { AddOn } from '../types';

type AddOnFooterProps = {
  addOn: AddOn;
  canTrial: boolean;
  onCloseModal: () => void;
  onError: (addOnCode: string) => void;
};

export const AddOnFooter = ({ addOn, canTrial, onCloseModal, onError }: AddOnFooterProps) => {
  const showPaymentDisclaimer = addOn.price.value !== 0;

  return (
    <>
      {canTrial ? (
        <FlexRow className={styles['try-for-free']}>
          <Text textType={TextType.Paragraph} value={<FormattedMessage {...messages.dueToday} />} />
          <Text
            textType={TextType.Paragraph}
            value={<FormattedCurrency currencyCode={addOn.price.code} fractionDigits={2} value={0.0} />}
          />
        </FlexRow>
      ) : null}
      <ConfirmAddOnUpsellButton addOn={addOn} onCloseModal={onCloseModal} onError={onError} />
      {showPaymentDisclaimer ? <PaymentDisclaimer addOn={addOn} /> : null}
    </>
  );
};
